export default [
    {
        path: '/:organisation/portals/team-members/invitations/:token',
        name: 'team-member-portal.accept-invitation',
        component: () => import(/* webpackChunkName: "tenants" */ '@/pages/[organisation]/portals/team-members/invitations/[token].vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
    },
];
